
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import defensiveCopy from "@/util/defensive-copy";
import { Trigger } from "@/types/conditions";
import DynamicDataFields from "@/components/Reusable/ControlsTree/DynamicData/DynamicDataFields.vue";
import DynamicDataDialog from "@/components/Reusable/ControlsTree/DynamicData/DynamicDataDialog.vue";
import TemplateRuleGroupInput from "@/components/Reusable/CustomInputs/Conditions/TemplateRuleGroupInput.vue";
import Icon from "@/components/UI/Icon.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import TriggerInput from "@/components/Reusable/CustomInputs/Triggers/TriggerInput.vue";
import { PopupTriggers } from "@/subapps/manage-templates/types";

@Component({
  components: {
    TriggerInput,
    NiceButton,
    Icon,
    DynamicDataFields,
    DynamicDataDialog,
    TemplateRuleGroupInput
  }
})
export default class TriggersMatrix extends Vue {
  @Prop()
  value!: Trigger[];

  @Prop()
  triggers!: PopupTriggers[];

  @Prop({ default: false })
  disableTriggerLimits!: boolean;

  addTrigger() {
    const newTriggers = defensiveCopy(this.value);
    newTriggers.push({});

    this.$emit("input", newTriggers);
  }

  deleteTrigger(groupIndex: number) {
    const newRuleGroups = defensiveCopy(this.value);
    newRuleGroups.splice(groupIndex, 1);

    this.$emit("input", newRuleGroups);
  }

  updateTrigger(newTrigger: Trigger, triggerIndex: number) {
    const newTriggers = defensiveCopy(this.value);
    newTriggers[triggerIndex] = newTrigger;

    this.$emit("input", newTriggers);
  }
}
